module.exports = __webpack_public_path__ + "static/search-page-982744027500aa37f4d52c29738a9fde.png";